import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';


export default {
  getReport(reportId) {
    return fetchV1.get(`/reports/${reportId}`);
  },
  getReportsList(filters) {
    return fetchV1.get(`/reports?${toQueryString(filters)}`);
  },
  submitReport(payload) {
    return fetchV1.post(`/reports`, payload);
  },
};
